module.exports = __webpack_public_path__ + "img/0Q3A8622_L_WoodMatted.3610831a.jpg";